import { useIsAuthenticated } from '@azure/msal-react';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PermissionProvider } from '../context/PermissionContext';
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import AddApplicant from '../pages/rec/applicant/AddApplicant';
import ApplicantSearch from '../pages/rec/applicant/ApplicantSearch';
import LinkedinSearch from '../pages/rec/linkedin/LinkedinSearch';
import AddVacancy from '../pages/rec/vacancy/AddVacancy';
import EditVacancy from '../pages/rec/vacancy/EditVacancy';
import VacancySearch from '../pages/rec/vacancy/VacancySearch';
import ViewVacancy from '../pages/rec/vacancy/ViewVacancy';

const AppRoutes: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <PermissionProvider>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/rec/applicant/search" element={<ApplicantSearch />} />
        {/* <Route path="/rec/applicant/search" element={<Profile />} /> */}
        {/* <Route path="/rec/applicant/search" element={<History />} /> */}
        {/* <Route path="/rec/applicant/search" element={<AdditionalInfo />} /> */}
        <Route path="/rec/vacancy/search" element={<VacancySearch />} />
        <Route path="/rec/applicant/add" element={<AddApplicant />} />
        <Route path="/rec/linkedin/search" element={<LinkedinSearch />} />
        <Route path="/rec/vacancy/add" element={<AddVacancy />} />
        <Route path="/rec/vacancy/search/:id/view" element={<ViewVacancy />} />
        <Route path="/rec/vacancy/search/:id/edit" element={<EditVacancy />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </PermissionProvider>
  );
};

export default AppRoutes;